import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Send } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const inp = "w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-[#666] focus:border-white/40 focus:outline-none transition-colors";
const topics = ["Ladebuchse", "Kamera", "Wasserschaden", "Backglass / Rückseite", "Lautsprecher / Mikrofon", "Software-Problem", "Sonstiges"];

export default function InquiryForm() {
  const [f, setF] = useState({ name: "", email: "", phone: "", device: "", topic: topics[0], message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/inquiries", f);
      setDone(data);
      toast.success("Anfrage gesendet! Wir melden uns mit einem Angebot.");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <section data-testid="inquiry" className="relative z-10 bg-[#050505] py-16 lg:py-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-4">Anfrage stellen</p>
        <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-4">Etwas anderes am iPhone?</h1>
        <p className="text-[#999] mb-8 max-w-xl">Ladebuchse, Kamera, Wasserschaden oder etwas ganz anderes – beschreib dein Anliegen und wir senden dir ein individuelles Angebot per E-Mail.</p>

        {done ? (
          <div data-testid="inquiry-success" className="glass rounded-3xl p-10">
            <CheckCircle2 size={44} className="text-white mb-5" />
            <h2 className="font-display text-3xl">Danke, {done.name}!</h2>
            <p className="text-[#aaa] mt-3">Deine Anfrage ist eingegangen (Referenz <span className="font-mono text-white">{done.reference}</span>). Wir prüfen sie und melden uns mit einem Angebot.</p>
            <button onClick={() => setDone(null)} className="mt-6 text-sm text-white underline underline-offset-4">Weitere Anfrage senden</button>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="inquiry-form" className="glass rounded-3xl p-8 space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input data-testid="inq-name" required value={f.name} onChange={set("name")} placeholder="Name" className={inp} />
              <input data-testid="inq-phone" value={f.phone} onChange={set("phone")} placeholder="Telefon (optional)" className={inp} />
            </div>
            <input data-testid="inq-email" required type="email" value={f.email} onChange={set("email")} placeholder="E-Mail" className={inp} />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input data-testid="inq-device" value={f.device} onChange={set("device")} placeholder="iPhone-Modell (optional)" className={inp} />
              <select data-testid="inq-topic" value={f.topic} onChange={set("topic")} className={inp}>
                {topics.map((t) => <option key={t} className="bg-[#0a0a0a]">{t}</option>)}
              </select>
            </div>
            <textarea data-testid="inq-message" required rows={4} value={f.message} onChange={set("message")} placeholder="Beschreibe dein Anliegen…" className={`${inp} resize-none`} />
            <button type="submit" disabled={loading} data-testid="inq-submit" className="w-full rounded-full bg-white text-[#050505] py-4 font-medium hover:bg-[#d1d5db] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2">
              <Send size={17} /> {loading ? "Wird gesendet…" : "Anfrage senden"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
